var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.7 182.9v512h292.6v-73.2H182.9V256h658.3v365.7H621.7v73.2h292.6v-512z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M548.6 780.3V438.9h-73.2v341.4L428.2 733l-51.8 51.8L512 920.3l135.6-135.5-51.7-51.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystem);
export default __webpack_public_path__ + "static/media/system.05a1de25f84a9233a3e92eeb3ee59810.svg";
export { ForwardRef as ReactComponent };